import { FC } from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from './types';

const BforLogoIcon: FC<SVGIconType> = ({ color, size = 33 }) => {
  const colorClasses = css({
    color: color || '#0028E2',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  });

  return (
    <div data-testid="bfor-logo-icon" className={colorClasses}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 33 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Bfor</title>
        <path
          d="M29.627 10.7515C29.802 10.0759 29.9229 9.37893 29.9229 8.64737C29.9229 3.87138 26.1166 0 21.4214 0C19.5854 0 17.8901 0.59816 16.5004 1.60431C15.1103 0.59816 13.4151 0 11.5786 0C6.88343 0 3.07708 3.87138 3.07708 8.64737C3.07708 9.37938 3.19847 10.0759 3.37293 10.7515C2.94231 11.1891 2.54954 11.6492 2.19324 12.1283C0.800311 14.0021 0 16.1737 0 18.4916C0 25.5494 7.38736 31.2711 16.5 31.2711C25.6126 31.2711 33 25.5494 33 18.4916C33 15.5816 31.7418 12.9 29.627 10.7515ZM27.0429 20.6631C25.601 22.2434 22.2133 25.0786 16.4677 25.0786C10.722 25.0786 7.28028 22.2425 5.86939 20.6621C5.41292 20.1508 5.57862 19.3463 6.20077 19.0578C8.04558 18.2031 11.9492 16.6893 16.4672 16.6893C20.9853 16.6893 24.8677 18.1947 26.7184 19.0509C27.3448 19.3408 27.5081 20.1531 27.0429 20.6631Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};

export { BforLogoIcon };
